import { useState } from "react";
import Form from "/src/components/form/Form";
import Field from "/src/components/UI/Field/Field";
import TextInput from "/src/components/UI/TextField/TextInput";
import ButtonAction from "/src/components/UI/Button/Button";
import { useForm } from "react-hook-form";
import companyService from "../../services/companyService";
import ChooseFile from "/src/components/UI/ChooseFile/ChooseFile";
import FormData from "form-data";
import AutoComplete from "/src/components/UI/AutoComplete/AutoComplete";
import userService from "/src/features/administration/user/services/userService";
function FormCompany({ form, onSend }) {
    const data = {
        id: form.id,
        name: form.name,
        image: form.logo,
        owner: form.owner,
        api_key_rag: form.api_key_rag,
    };
    const {
        register, handleSubmit, formState: { errors }, getValues, setValue } = useForm({
            mode: "onChange",
            defaultValues: {
                id: data.id,
                image: data.image, // form.statementArray,
                owner: data.owner,
                api_key_rag: data.api_key_rag,
            },
        });

    const { addCompany, updateCompany } = companyService;
    const { getUsersAutocomplete } = userService;
    const [file, setFile] = useState(data.image);
    const [loadAnim, setLoading] = useState(null);

    const onSubmit = async () => {
        var dataToSend = getValues();

        const formData = new FormData();
        formData.append("name", dataToSend.name);
        if (dataToSend.api_key_rag) {
            formData.append("api_key_rag", dataToSend.api_key_rag);
        }

        if (data.image != file) {
            // useless to change the same picture
            formData.append("image", file);
        }
        // A RAJOUTER PLUS TARD LE OWNER
        if (data.id != undefined) {
            // mean we are in update form since we have data
            if (dataToSend.owner != data.owner) {
                formData.append("owner_id", dataToSend.owner);
            }
            let [response, error] = await updateCompany(data.id, formData);

            if (error !== null) {
                console.log(error);
                return;
            }

            formData.id = response._id;
            if (onSend != null) {
                onSend(response);
            }
            return;
        }

        let [response, error] = await addCompany(formData);
        if (error !== null) {
            console.log(error);
            return;
        }

        formData.id = response._id;
        if (onSend != null) {
            onSend(response);
        }
        return;
    };
    return (
        <div>
            <Form className="edit-container" onSubmit={handleSubmit(onSubmit)}>
                <Form.Title>{form.title}</Form.Title>
                <Form.Body className="body-editModal-container">
                    <div className="modal-bar" style={{ display: "block" }}>
                        <div style={{ marginBottom: "15px" }}>
                            <Field label="Name" />
                            <TextInput
                                {...register("name", { required: true, minLength: 1 })}
                                style={errors.label ? { borderColor: "red" } : {}}
                                className="full-width input_company_ModalBody"
                                defaultValue={data ? data.name : ""}
                                placeholder="Choose your name"
                            />
                        </div>

                        {data.name ? ( // check if datas exists
                            <div>
                                <Field label="Owner of the organization" />
                                <AutoComplete name="owner" value={data?.owner} className="full-width input_company_ModalBody" getItemValue={(name, item) => setValue(name, item.id)} apiCall={getUsersAutocomplete} getImageFromItem={(item) => item.picture} placeholder="Choose the owner" getNameFromItem={(item) => item.username}></AutoComplete>

                            </div>
                        ) : (
                            ""
                        )}
                        <div style={{ marginTop: "15px" }}>
                            <Field label="API Key (RAG)" />
                            <TextInput
                                {...register("api_key_rag")}
                                style={errors.api_key_rag ? { borderColor: "red" } : {}}
                                className="full-width input_company_ModalBody"
                                defaultValue={data ? data.api_key_rag : ""}
                                placeholder="Enter API Key"
                            />
                        </div>
                    </div>

                    <div>
                        <div>
                            <Field label="Logo" />
                            <ChooseFile
                                _setFile={setFile}
                                defaultValueImage={data.image}
                                accept=".png,.jpg,.jpeg"
                                loadAnim={loadAnim}
                                colorBorder={"inset 0 0 0 1px #dddddd;"}></ChooseFile>
                        </div>
                    </div>
                </Form.Body>
                <Form.Buttons>
                    <ButtonAction
                        type="submit"
                        label={data.id ? "Update" : "Add"}
                        disabled={Object.keys(errors).length != 0}
                        onSubmit={onSubmit}></ButtonAction>
                </Form.Buttons>
            </Form>
        </div>
    );
}
export default FormCompany;
